import { TableCell as TiptapTableCell } from '@tiptap/extension-table-cell';

const TableCell = TiptapTableCell.extend({
  addAttributes() {
    return {
      ...(this.parent ? this.parent() : {}),
      style: {
        default: null,
        parseHTML: (element: Element) => {
          return element.getAttribute('colwidth');
        },
        renderHTML: (attributes) => {
          return {
            colspan: attributes.colspan,
            rowspan: attributes.rowspan,
            colwidth: attributes.colwidth,
            style: attributes.style ? `width: ${attributes.style}px` : null,
          };
        },
      },
    };
  },
});

export default TableCell;
